import { useEffect, useState, useRef } from 'react'
import { useTableMetadataStore } from "../../_stores"
import TableCell from './_TableCell'

function TableRow({ rowData, rowId, rowIndex }, ref) {
	const selectedRows = useTableMetadataStore(state => state.selectedRows)
	const addSelectedRow = useTableMetadataStore(state => state.addSelectedRow)
	const removeSelectedRow = useTableMetadataStore(state => state.removeSelectedRow)

	const [isRowSelected, setIsRowSelected] = useState(selectedRows.includes(rowId))

	if (!ref) ref = useRef(null)
	// methods
	const updateCellData = (cellIndex, newValue, fireEvent = true, additionalParams = undefined) => {
		const row = ref.current
		row.querySelector(`td[data-index="${cellIndex}"]`).updateData(newValue, fireEvent, additionalParams)
	}

	const getCellData = (cellIndex) => {
		const row = ref.current
		return row.querySelector(`td[data-index="${cellIndex}"]`).getData()
	}

	const getCell = (cellIndex) => {
		const row = ref.current
		return row.querySelector(`td[data-index="${cellIndex}"]`)
	}

	const handleRowSelect = (active) => {
		setIsRowSelected(active)
	}

	useEffect(() => {
		ref.current.updateCell = updateCellData
		ref.current.getCellData = getCellData
		ref.current.getCell = getCell
		
		ref.current.rowId = rowId
		ref.current.select = handleRowSelect
	}, [ref.current])

	useEffect(() => {
		ref.current.rowId = rowId
	}, [rowData])

	useEffect(() => {
		if (isRowSelected) {
			addSelectedRow(ref.current)
		} else {
			removeSelectedRow(rowId)
		}
	}, [isRowSelected])

	useEffect(()=>{
		if(selectedRows.find(row => row.rowId.toString() === rowId.toString())){
			setIsRowSelected(true)
		} else {
			setIsRowSelected(false)
		}
	}, [selectedRows])

	return (
		<tr data-row-id={rowId} data-index={rowIndex} ref={ref} className={isRowSelected ? 'selected' : ''}>
			<td data-header="Select Row">
				<input type="checkbox" className="mt-1" onChange={(e) => {
					handleRowSelect(e.target.checked)
				}} checked={isRowSelected} />
			</td>
			{
				rowData?.map((cellData, columnIndex) => {
					return (
						<TableCell key={columnIndex} data={cellData} index={columnIndex} />
					)
				})
			}
		</tr>
	)
}

export default React.forwardRef(TableRow)